import { IntegrationsListComponent } from './components/integrations-list/integrations-list.component';
import { Route } from '@angular/router';

import { IntegrationsGuard } from './integrations.guard';
import { IntegrationsSettingsComponent } from './integrations.component';
import { OneDriveIntegrationComponent } from './components/one-drive-integration/one-drive-integration.component';

export const integrationsRoutes: Route[] = [
  {
    path: '',
    component: IntegrationsSettingsComponent,
    canActivate: [IntegrationsGuard],
    children: [
      {
        path: '',
        component: IntegrationsListComponent,
      },
      {
        path: 'one-drive',
        component: OneDriveIntegrationComponent,
        resolve: {},
      },
    ],
  },
];
